import Api from './index'
import { IITXResponse } from './types/idin'

export const identifyIdin = (redirectUrl: string, email: string) => Api<IITXResponse>('GET', 'idin/ITX', { email, redirect_url: redirectUrl })

export const verifyIdin = (entranceCode: string, transactionId: string, registerUrl: string, email: string) => Api<IITXResponse>('GET', 'idin/ISX', { email, entranceCode, registerUrl, transactionId })
